export default __webpack_public_path__ + "static/media/woman-and-square.0639b08e.svg";